{
    "locale": "it-IT",
    "error": {
        "unsupportedMethod": "Metodo non supportato: {method}"
    },
    "account": {
        "deleteTokenTooltip": "Eliminare definitivamente il token?",
        "deleteToken": "Elimina token",
        "apiAccountToken": "Token account API",
        "createApiToken": "Crea un nuovo token account API",
        "createToken": "Crea token",
        "existingTokens": "Token esistenti",
        "noApiTokensCreated": "Non sono stati ancora creati token account API.",
        "description": "Descrizione",
        "createdOn": "Creato il",
        "token": "Token",
        "saveTokenWarning": "Salva con cura questo token, non potrà essere mostrato di nuovo.",
        "hint": "Suggerimento",
        "tokenCopiedNotification": "Il token è stato copiato negli appunti.",
        "registrationNotice": "Si prega di notare che la registrazione a eInfo è possibile solo per i rivenditori già elencati.",
        "registrationDescription": "Registrandoti qui, ottieni non solo l'accesso al nostro shop, ma anche alla nostra piattaforma di conoscenza eInfo:",
        "informationAvailableTitle": "Informazioni disponibili sempre e ovunque",
        "statusQuery": "Richiesta di stato di offerte e ordini",
        "downloadDocuments": "Download di offerta, conferma d'ordine e fattura",
        "downloadImages": "Download di immagini 2D e 3D e file DXF",
        "tracking": "Tracciamento spedizione",
        "customerLink": "Informare clienti e installatori tramite link sugli stati",
        "recognizeChargeable": "Riconoscere immediatamente le operazioni fatturabili",
        "viewInvoices": "Visualizzare le fatture inviate nell’ordine",
        "andMore": "E molto altro",
        "oneClickSolutionTitle": "La soluzione con un solo clic",
        "inquiryExample": "Inviare richiesta (es. in caso di modifica offerta)",
        "requestManual": "Richiedi manuale di montaggio",
        "registerNow": "Registrati ora gratuitamente:",
        "requestAccess": "Richiedi accesso",
        "companyData": "Dati aziendali",
        "customerNumber": "Numero cliente",
        "company": "Azienda",
        "streetAndHouseNumber": "Via e numero civico",
        "postcode": "CAP",
        "city": "Città",
        "country": "Paese",
        "personalAccess": "Accesso personale",
        "salutation": "Titolo",
        "firstName": "Nome",
        "lastName": "Cognome",
        "position": "Funzione",
        "email": "E-mail",
        "phone": "Telefono",
        "mobilePhone": "Cellulare",
        "fax": "Fax",
        "user": "Utente",
        "termsAcceptance": "Ho letto e accetto",
        "termsAndConditions": "le condizioni d'uso",
        "privacyPolicy": "l’informativa sulla privacy",
        "submitRequest": "Invia richiesta",
        "acknowledged": "letto e accettato",
        "requestForwarded": "La richiesta è stata inoltrata.",
        "resetPassword": "Reimposta password",
        "passwordMismatch": "La password e la conferma non corrispondono!",
        "passwordComplexity": "La complessità della password non è sufficiente. Utilizzare una combinazione di lettere (maiuscole e minuscole), numeri e caratteri speciali con una lunghezza minima di 8 caratteri.",
        "passwordSetSuccess": "La tua password è stata impostata. Ora puoi accedere con le tue credenziali.",
        "passwordChangeSuccess": "La tua password è stata modificata.",
        "errorOccurred": "Si è verificato un errore. Riprova più tardi.",
        "passwordResetLinkSent": "Se esiste un accesso per il nome utente specificato, un link per reimpostare la password è stato inviato all'indirizzo email registrato.",
        "setPasswordTitle": "Imposta password",
        "setPasswordDescription": "Imposta una nuova password per il tuo nuovo accesso. Potrai accedere subito con il tuo nome utente e la password scelta.",
        "changePasswordTitle": "Cambia password",
        "newPasswordPlaceholder": "nuova password",
        "repeatPasswordPlaceholder": "ripeti password",
        "termsAndConditionsRead1": "Ho letto",
        "termsAndConditionsRead2": "e accetto",
        "submitButton": "invia",
        "accessDenied": "Accesso negato!",
        "closeInfo": "Le tue richieste di modifica saranno verificate.",
        "unlockColleague": "Sblocca collega",
        "sendChanges": "Invia modifiche richieste",
        "firstname": "Nome",
        "lastname": "Cognome",
        "submitChangeRequest": "Invia modifiche richieste",
        "accessNumber": "Numero di accesso",
        "changeRequestInProgress": "Le tue richieste di modifica sono in fase di verifica.",
        "iAccept": "Accetto",
        "haveRead": "di aver letto",
        "request": "richiedi",
        "customerBase": "Base clienti",
        "documentationHTML": "<h2>Documentazione</h2><p>Per scoprire come utilizzare l'API, consulta la nostra <a href=\"{frontendBase}/tibi-api/_/{namespace}/_/assets/redoc/\" target=\"_blank\">documentazione API</a>.</p><p>L'API è una REST API che può essere utilizzata con qualsiasi client HTTP.</p><p>Per l'autenticazione, devi inserire il token generato nell'intestazione HTTP \"account-token-v1\".</p><h3>Esempio</h3><p><code>curl 'https://einfo.renzgroup.com/api/operation?limit=10&offset=0&sort=-insertTime'<br />&nbsp; -H \"accept: application/json\"<br />&nbsp; -H \"account-token-v1: TOKEN\"</code></p>"
    },
    "header": {
        "watchlist": "Lista dei preferiti",
        "processInformationSystem": "Sistema di informazione delle operazioni",
        "switchAccount": "Cambia account",
        "changeMasterData": "Modifica dati anagrafici",
        "changePassword": "Cambia password",
        "template": "Modello",
        "priceCalculation": "Calcolo del prezzo",
        "addressBook": "Rubrica",
        "integrations": "Integrazioni",
        "token": "Token",
        "logout": "Disconnetti",
        "login": "Accedi",
        "more": "Altro",
        "copyrightPage": "Note legali",
        "logoutIn": "logout tra {logoutInMinutes} min"
    },
    "notifications": {
        "successfulLogout": "Disconnessione avvenuta con successo.",
        "failedLogout": "Si è verificato un errore durante il login. Verifica le tue credenziali.",
        "resubmissionSuccessfullyUpdated": "Promemoria aggiornato con successo.",
        "resubmissionSuccessfullyCreated": "Promemoria creato con successo.",
        "changesGotSaved": "Le modifiche sono state salvate con successo."
    },
    "cart": {
        "cancel": "annullare",
        "moveToCart": "spostare nel carrello",
        "move": "spostare",
        "referenceOfferNotFound": "Offerta di riferimento non trovata",
        "mapping": {
            "refNumber": "Numero di riferimento",
            "number": "Numero",
            "endCustomerEmail": "E-mail cliente finale",
            "endCustomerPhone": "Telefono cliente finale",
            "endCustomerAddress": {
                "label": "Indirizzo cliente finale",
                "name1": "Nome 1",
                "name2": "Nome 2",
                "name3": "Nome 3",
                "street": "Via",
                "country": "Paese",
                "postcode": "CAP",
                "city": "Città"
            },
            "endCustomerVAT": "IVA cliente finale",
            "sumEndCustomerPrice": "Prezzo cliente finale",
            "sumEndCustomerPriceGross": "Prezzo cliente finale IVA inclusa",
            "type": {
                "label": "Tipo",
                "1": "Offerta",
                "2": "Ordine"
            },
            "source": {
                "label": "Origine",
                "10": "Back Office",
                "20": "eConfig Pro (RIK)",
                "30": "eConfig (VR)",
                "31": "eAssist",
                "40": "RIT",
                "50": "eShop",
                "60": "eInfo",
                "80": "Aziende collegate VU",
                "90": "LIK"
            },
            "statusSummary": {
                "label": "Riepilogo stato",
                "created": {
                    "label": "Creato",
                    "0": "no",
                    "30": "in lavorazione",
                    "100": "completato"
                },
                "emailed": {
                    "label": "Inviato",
                    "0": "no",
                    "100": "sì"
                }
            },
            "orderedSummary": {
                "label": "Riepilogo ordine",
                "ordered": {
                    "label": "Ordinato",
                    "0": "no",
                    "100": "sì"
                },
                "orderedCount": "Quantità ordinata"
            },
            "endCustomerFullAddress": {
                "label": "Indirizzo completo cliente finale",
                "id": "ID",
                "insertTime": "Data inserimento",
                "updateTime": "Data aggiornamento",
                "dealerNumber": "Numero rivenditore",
                "type": {
                    "label": "Tipo",
                    "person": "Persona",
                    "company": "Azienda"
                },
                "vat": "IVA",
                "company": {
                    "label": "Azienda",
                    "name": "Nome",
                    "vatId": "Partita IVA",
                    "firstname": "Nome",
                    "lastname": "Cognome",
                    "paymentTerms": "Condizioni di pagamento"
                },
                "person": {
                    "label": "Persona",
                    "salutation": "Titolo",
                    "firstname": "Nome",
                    "lastname": "Cognome",
                    "parentCompany": "Casa madre"
                },
                "location": {
                    "label": "Sede",
                    "street": "Via",
                    "houseNumber": "Numero civico",
                    "supplement": "Supplemento",
                    "postcode": "CAP",
                    "city": "Città",
                    "country": "Paese"
                },
                "contact": {
                    "label": "Contatto",
                    "phone": "Telefono",
                    "fax": "Fax",
                    "email": "E-mail",
                    "website": "Sito web"
                },
                "customerNumber": "Numero cliente",
                "priceCalculation": "Calcolo del prezzo",
                "notModifyablePCalc": "Calcolo prezzo non modificabile",
                "deliveryAddress": {
                    "label": "Indirizzo di consegna",
                    "salutation": "Titolo",
                    "name1": "Nome 1",
                    "name2": "Nome 2",
                    "name3": "Nome 3",
                    "street": "Via",
                    "country": "Paese",
                    "postcode": "CAP",
                    "city": "Città",
                    "phone": "Telefono",
                    "fax": "Fax",
                    "email": "E-mail"
                }
            },
            "dealerNumber": "Numero rivenditore",
            "inquiryDate": "Data richiesta",
            "inquiryNumber": "Numero richiesta",
            "receiptDate": "Data ricezione",
            "releaseDate": "Data rilascio",
            "constructionProject": "Progetto di costruzione",
            "constructionSite": "Cantiere",
            "commission": "Commissione",
            "residentialUnitsCount": "Numero unità abitative",
            "deliveryAddress": {
                "label": "Indirizzo di consegna",
                "salutation": "Titolo",
                "name1": "Nome 1",
                "name2": "Nome 2",
                "name3": "Nome 3",
                "street": "Via",
                "country": "Paese",
                "postcode": "CAP",
                "city": "Città",
                "phone": "Telefono",
                "fax": "Fax",
                "email": "E-mail"
            },
            "inquiryContact": {
                "label": "Responsabile / Ordinante",
                "name": "Nome"
            },
            "endCustomer": {
                "label": "Cliente finale",
                "name": "Nome"
            },
            "sumNetPrice": "Valore netto merce",
            "sumRetailPrice": "Prezzo al pubblico",
            "clerk": {
                "label": "Responsabile",
                "name": "Nome",
                "email": "E-mail"
            },
            "internalClerk": {
                "label": "Responsabile interno",
                "name": "Nome"
            },
            "additionalPositions": {
                "label": "Posizioni aggiuntive",
                "number": "Numero",
                "service": "Servizio",
                "description": "Descrizione",
                "netPrice": "Prezzo netto",
                "amount": "Quantità"
            },
            "documentTemplateTextContent": {
                "label": "Contenuto testo modello documento",
                "emailSubject": "Oggetto e-mail",
                "emailBody": "Testo e-mail",
                "pdfIntro": "Introduzione PDF",
                "pdfOutro": "Conclusione PDF",
                "preLetter": "Lettera introduttiva",
                "deliveryTime": "Tempi di consegna",
                "paymentTerms": "Condizioni di pagamento",
                "contact": {
                    "label": "Contatto",
                    "useLoggedInUserAsDefault": "Utilizza utente connesso come predefinito",
                    "name": "Nome",
                    "phone": "Telefono",
                    "email": "E-mail",
                    "webUrl": "Sito web"
                }
            }
        },
        "positions": {
            "label": "Posizioni",
            "number": "Numero",
            "type": "Tipo",
            "quantity": "Quantità",
            "orderQuantity": "Quantità nell'ordine",
            "color": {
                "label": "Colore",
                "code": "Codice colore",
                "name": "Nome colore"
            },
            "additionalItems": {
                "label": "Articoli aggiuntivi",
                "number": "Numero",
                "description": "Descrizione",
                "netPrice": "Prezzo netto",
                "service": "Servizio",
                "amount": "Quantità"
            },
            "state": {
                "label": "Stato",
                "code": "Codice",
                "description": "Descrizione",
                "blockingIndicator": "Indicatore di blocco"
            },
            "delivery": {
                "label": "Consegna",
                "plannedDate": "data prevista",
                "plannedDateNew": "nuova data prevista",
                "plannedWeek": "settimana prevista",
                "actualDate": "data effettiva",
                "shippingCompany": "Codice corriere"
            },
            "origin": {
                "label": "Origine",
                "operationNumber": "Numero operazione",
                "positionNumber": "Numero posizione"
            },
            "residentialUnitsCount": "Numero unità abitative",
            "residentialUnitsCountTotal": "Totale unità abitative",
            "rikNumber": "Numero ECP",
            "productGroup": "Gruppo prodotto",
            "modelGroup": "Gruppo modello",
            "installationType": "Tipo di installazione",
            "netPrice": "Prezzo netto",
            "endCustomerPrice": "Prezzo cliente finale",
            "endCustomerPriceGross": "Prezzo cliente finale IVA inclusa",
            "retailPrice": "Prezzo consigliato",
            "alternativeTo": "Alternativa a",
            "objectionPeriodEnd": "Fine del periodo di opposizione",
            "instructionsAvailable": "Istruzioni di montaggio disponibili",
            "specialCAD": "CAD speciale",
            "items": {
                "label": "Elementi della posizione",
                "sequenceNumber": "numero progressivo",
                "amount": "Quantità",
                "measureUnit": "Unità di misura",
                "number": "Numero d’ordine",
                "description": "Descrizione"
            },
            "tracking": {
                "label": "Tracking",
                "sequenceNumber": "numero progressivo",
                "trackingNumber": "Numero di tracciamento",
                "status": "Stato",
                "receiver": "Destinatario"
            },
            "chargeable": "fatturabile",
            "chargeableReason": "fatturabile - motivo"
        },
        "updated": "Il carrello {name} è stato aggiornato.",
        "updateFailedS": "Il carrello {name} non può essere aggiornato!",
        "inCartTooltip": "Questa offerta si trova nei seguenti carrelli:",
        "addToCartTooltip": "Aggiungi al carrello",
        "dataTakeover": "Adotta i dati dall'offerta:",
        "dataOvertake": "Adozione dati",
        "missingRequiredFields": "Compila tutti i campi obbligatori!",
        "noDataAvailable": "Non ci sono dati disponibili per questa posizione.",
        "moveOffer": "Sposta offerta in un altro carrello",
        "moveOfferDisabled": "L'offerta non può essere spostata perché non esiste un altro carrello.",
        "copyOffer": "Copia offerta in un altro carrello",
        "copyOfferDisabled": "L'offerta non può essere copiata perché non esiste un altro carrello.",
        "deleteOffer": "Rimuovi offerta dal carrello",
        "moveOfferS": "Sposta offerta",
        "deliveryAddress": "Indirizzo di consegna",
        "created": "Il carrello {name} è stato creato.",
        "createFailed": "Il carrello {name} non può essere creato!",
        "cart": "Carrello",
        "carts": "Carrelli",
        "copyOfferS": "Copia offerta",
        "phoneNotificationChosen": "È stata selezionata la notifica telefonica. Compila i campi richiesti.",
        "cartDeleted": "Il carrello è stato eliminato.",
        "cartDeleteFailed": "Il carrello non può essere eliminato!",
        "orderSent": "L'ordine è stato inviato.",
        "back": "Indietro",
        "addressUpdated": "L'indirizzo è stato aggiornato.",
        "addressUpdateFailed": "L'indirizzo non può essere aggiornato, controlla i dati inseriti!",
        "addressCreated": "L'indirizzo è stato aggiunto alla rubrica.",
        "addressCreateFailed": "L'indirizzo non può essere aggiunto alla rubrica, controlla i dati inseriti!",
        "orderFailed": "L'ordine non può essere inviato!",
        "updateFailed": "Il carrello non può essere aggiornato!",
        "costNotice": "Attenzione ai costi che potrebbero sorgere. Al momento non sono previsti costi.",
        "phoneNotificationRequested": "Notifica telefonica desiderata?",
        "phoneNotification": "Telefono di avviso",
        "editCart": "Modifica carrello",
        "deleteCart": "Elimina carrello",
        "cartIcon": {
            "inCartTooltip": "Questa offerta si trova nei seguenti carrelli: {foundInCarts}",
            "addMarkedItemsTooltip": "Aggiungi tutte le posizioni selezionate al carrello",
            "addAllItemsTooltip": "Aggiungi tutte le posizioni al carrello."
        },
        "updateSuccess": "Il nome del carrello è stato modificato.",
        "updateError": "Il nome del carrello non può essere modificato!",
        "createSuccess": "Il nuovo carrello è stato creato.",
        "createError": "Il nuovo carrello non può essere creato!",
        "createNewCartName": "Nuovo carrello",
        "addCart": "Aggiungi carrello",
        "createSuccessNotification": "Il carrello è stato creato con successo.",
        "deleteSuccessNotification": "Il carrello è stato eliminato con successo.",
        "updateSuccessNotification": "Il carrello è stato aggiornato.",
        "updateErrorNotification": "Il carrello non può essere aggiornato.",
        "noCartsCreated": "Attualmente non sono stati ancora creati carrelli.",
        "deleteModalTitle": "Elimina carrello",
        "deleteModalMessage": "Vuoi davvero eliminare il carrello <strong>{cartName}</strong>?",
        "deleteButton": "Elimina carrello",
        "total": "Totale",
        "amountPos": "Num. pos.",
        "totalSum": "Importo totale",
        "sendOrder": "Invia ordine",
        "saveData": "Dati salvati",
        "lookInAddressBook": "Cerca nella rubrica",
        "deviatingShippingAddress": "Indirizzo di consegna diverso",
        "homeAddress": "Indirizzo principale",
        "shippingAddress": "Indirizzo di consegna",
        "commission": "Commissione",
        "commissionPlaceholder": "Inserisci commissione",
        "constructionProject": "Progetto di costruzione",
        "constructionProjectPlaceholder": "Inserisci progetto",
        "shipment": {
            "selectCalendarWeek": "Seleziona settimana",
            "dontShipBefore": "Non spedire prima della settimana n°:"
        },
        "legend": {
            "legend": "Legenda",
            "operationCreated": "Operazione creata",
            "inProgress": "in lavorazione",
            "offerCreated": "Offerta creata",
            "mandatoryField": "Campo obbligatorio"
        },
        "modals": {
            "copy": "Copia",
            "confirmDataTakeover": {
                "header": "Adottare dati",
                "body": "Vuoi davvero adottare i dati dall'offerta {number} nel carrello attuale?",
                "cancel": "Annulla",
                "confirm": "Adotta dati"
            },
            "deleteCartOperation": {
                "header": "Rimuovi dal carrello",
                "body": "Vuoi davvero rimuovere l'offerta {number} dal carrello?",
                "cancel": "Annulla",
                "confirm": "Elimina"
            },
            "addressUpdate": {
                "headerCreate": "Crea indirizzo",
                "headerUpdate": "Aggiorna indirizzo",
                "bodyCreate": "Vuoi davvero creare l'indirizzo?",
                "bodyUpdate": "Vuoi davvero aggiornare l'indirizzo?",
                "cancel": "Annulla",
                "confirmCreate": "Crea",
                "confirmUpdate": "Aggiorna"
            },
            "moveCartOperation": "Sposta offerta in un altro carrello",
            "copyCartOperation": "Copia offerta in altri carrelli",
            "orderCart": {
                "header": "Ordina carrello",
                "body": "Vuoi davvero inviare l'ordine {name}?",
                "cancel": "Annulla",
                "confirm": "Invia ordine"
            },
            "cartDeletion": {
                "header": "Elimina carrello",
                "body": "Il carrello è vuoto. Vuoi eliminare il carrello {name}?",
                "cancel": "Annulla",
                "confirm": "Elimina",
                "success": "Il carrello è stato eliminato.",
                "error": "Il carrello non può essere eliminato!"
            }
        },
        "assignOperation": {
            "title": "Sposta offerta nel carrello",
            "newCartLabel": "Nuovo carrello",
            "tooltipAddToCart": "Aggiungi al carrello",
            "cancelButtonLabel": "Annulla",
            "submitButtonLabel": "Aggiungi",
            "invalidCartNameTooltip": "Nome del carrello non valido. Controlla se il nome esiste già e se è corretto.",
            "noCartNameTooltip": "Inserisci un nome per il carrello o seleziona un carrello.",
            "selectCartTooltip": "Aggiungi al carrello"
        }
    },
    "tableColumns": {
        "source": {
            "label": "O",
            "tooltip": "Origine"
        },
        "dealerNumber": {
            "label": "N. cliente",
            "tooltip": "Numero rivenditore"
        },
        "releaseDate": {
            "label": "Data offerta"
        },
        "insertTimeOut1": {
            "label": "Data offerta"
        },
        "insertTimeOut2": {
            "label": "Data conferma ordine"
        },
        "number": {
            "labelOffer": "N. offerta",
            "labelOrder": "N. ordine"
        },
        "countOfPositions": {
            "label": "N. pos.",
            "tooltip": "Numero delle posizioni"
        },
        "status": {
            "label": "Stato"
        },
        "canceled": {
            "label": "Annullato"
        },
        "chargeable": {
            "label": "Fatturabile",
            "tooltip": "Fatturabile",
            "labelShort": "F"
        },
        "inquiryDate": {
            "label": "Data richiesta"
        },
        "releaseDateOrder": {
            "label": "Data ordine"
        },
        "endCustomerName": {
            "label": "Richiesta / Nome"
        },
        "inquiryNumber": {
            "labelInquiry": "N. richiesta",
            "labelOrder": "N. ordine"
        },
        "constructionProject": {
            "label": "Progetto"
        },
        "commission": {
            "label": "Commissione"
        },
        "constructionSite": {
            "label": "Cantiere"
        },
        "inquiryContact": {
            "label": "Responsabile"
        },
        "lastUpdatedBy": {
            "label": "Ultima modifica di"
        },
        "deliveryAddress": {
            "label": "Indirizzo di consegna",
            "noDeliveryAddress": "Nessun indirizzo di consegna"
        },
        "endCustomerFullAddress": {
            "label": "Cliente finale – Nome",
            "address": "Indirizzo cliente finale"
        },
        "residentialUnitsCount": {
            "label": "UE",
            "tooltip": "Unità abitative"
        },
        "sumNetPrice": {
            "label": "Totale"
        },
        "followUpListOwner": {
            "label": "Proprietario lista"
        },
        "description": {
            "label": "Descrizione"
        },
        "insertTime": {
            "label": "Creato il"
        },
        "lastUsed": {
            "label": "Ultimo utilizzo"
        }
    },
    "bookmarks": {
        "icon": {
            "editOwnResubmissionsOnly": "Puoi modificare solo i tuoi promemoria.",
            "removeFromWatchlist": "Rimuovi dalla lista",
            "addToWatchlist": "Aggiungi alla lista"
        },
        "addBookmarks": "Aggiungi segnalibro",
        "addedBookmarks": "Segnalibro aggiunto",
        "removeBookmarks": "Rimuovi segnalibro",
        "removedBookmarks": "Segnalibro rimosso",
        "offers": "Offerte",
        "orders": "Ordini",
        "outgoingOffers": "Offerte in uscita",
        "orderConfirmations": "Conferme d’ordine",
        "bookmarks": "Lista",
        "myBookmarks": "La mia lista",
        "fullTextSearch": "Ricerca testuale completa",
        "resetFilter": "Reimposta filtro"
    },
    "login": {
        "successNotification": "Hai effettuato l'accesso con successo al sistema eInfo.",
        "failNotification": "Si è verificato un errore durante il login. Controlla le tue credenziali.",
        "mfaNotification": "È necessaria un'autenticazione aggiuntiva. Inserisci il codice ricevuto via e-mail.",
        "unknownErrorNotification": "Errore sconosciuto durante il login.",
        "enterMfaCode": "Inserisci il codice che ti è stato inviato via e-mail.",
        "usernamePlaceholder": "Utente",
        "passwordPlaceholder": "Password",
        "submitButton": "invia",
        "resetPassword": "Reimposta password",
        "requestAccess": "Richiedi accesso",
        "login": "Accedi",
        "code": "Codice"
    },
    "integrations": {
        "configIntegrations": "Integrazione configuratore",
        "iframeRecommendation": "Si consiglia un’altezza minima di <b>800px</b> e una larghezza minima di <b>1000px</b> per l’integrazione dell’iFrame.",
        "contactDataPrepopulation": "Precompilazione dei dati di contatto (opzionale)",
        "useCustomerData": "È possibile precompilare il configuratore con i dati anagrafici del cliente connesso.",
        "fieldsToPrepopulate": "I seguenti campi possono essere precompilati e aggiunti tramite i nomi dei campi nell’URL:",
        "dealerErrorHeader": "Il rivenditore con numero {dealerNumbers} non è completamente configurato per l’uso nel configuratore!",
        "dealerErrorInstructions": "Verifica che il modello d’offerta sia configurato correttamente nell’account del rivenditore e sia abilitato per l’uso.",
        "preDefInsert": "Inserisci la preimpostazione nel codice {additionalInfo}",
        "iframePreview": "e anteprima iFrame",
        "colorStyle": "Stile colore",
        "selectColorStyle": "Seleziona stile colore",
        "backgroundColor": "Colore di sfondo (opzionale)",
        "dealerCustomer": "Cliente rivenditore",
        "dealerCustomers": "Clienti rivenditori",
        "enterNumberOrName": "Inserisci numero / nome",
        "sourceCode": "Codice sorgente per il tuo sito",
        "preview": "Anteprima",
        "fieldName": "Nome campo",
        "importance": "Importanza",
        "example": "Esempio",
        "noEntriesFound": "Nessun risultato trovato",
        "dealerIsntAvailable": "Il rivenditore non è configurato o abilitato per il configuratore.",
        "integrationsMap": {
            "firstname": "Nome",
            "lastname": "Cognome",
            "company": "Azienda",
            "city": "Città",
            "street": "Via",
            "houseNumber": "Numero civico",
            "postcode": "CAP",
            "countryCode": "Codice paese",
            "email": "E-mail",
            "phone": "Telefono"
        }
    },
    "operationsLegend": {
        "legendTitle": "Legenda",
        "createdOperation": "Operazione creata",
        "inProgress": "in lavorazione",
        "offerCreated": "Offerta creata",
        "cancellation": "Annullamento",
        "partialCancellation": "Annullamento parziale",
        "statusDescriptionTitle": "Descrizione dello stato",
        "notStarted": "non iniziato",
        "inProcess": "in corso",
        "delayed": "in ritardo",
        "partlyDone": "parzialmente completato",
        "completed": "completato",
        "orderConfirmation": "Conferma d’ordine",
        "objectionPeriod": "Periodo di opposizione",
        "manufacture": "Produzione",
        "shipping": "Spedizione",
        "delivery": "Consegna"
    },
    "followUp": {
        "onMyList": "nella mia lista",
        "ownAndForeign": "Hai {total} promemoria scadut{plural}. Di questi, {ownCount} tuoi e {foreignCount} di altri.",
        "onlyOwn": "Hai {total} promemoria scadut{plural}.",
        "added": "Promemoria aggiunto",
        "removed": "Promemoria rimosso"
    },
    "operations": {
        "shareTransaction": "condividere questa operazione tramite link",
        "inquiryS": "Richiesta su {opNumber}",
        "inquiryContact": "Responsabile",
        "protocol": "Protocollo di {opNumber}",
        "email": "Email su {opNumber}",
        "offerType1": "{offerTabTitle_Type1} {opNumber}",
        "orderConfirmation": "Conferma d’ordine {opNumber}",
        "orderS": "Ordine {opNumber}",
        "offerT": "Offerta",
        "offer": "Inviare richiesta per l'intera offerta",
        "linkSent": "Il link è stato inviato con successo a '{email}'.",
        "invalidEmail": "'{email}' non è un indirizzo email valido.",
        "showPositionDetails": "Mostra dettagli della posizione.",
        "incompleteOperation": "Questa operazione non è ancora completamente creata.",
        "linkRegenerated": "Il link è stato rigenerato. Il vecchio link non è più valido.",
        "linkDeactivated": "Il link è stato disattivato.",
        "linkCopied": "Il link è stato copiato negli appunti.",
        "linkCopyFailed": "Impossibile copiare il link negli appunti. {text}",
        "order": "Ordine",
        "share": "condividi",
        "linkDescription": "Tramite un link, altre persone (es. clienti) possono visualizzare questa operazione.",
        "noPriceInfo": "Chi apre il link non potrà vedere i prezzi o le condizioni.",
        "copyLinkHint": "Puoi copiare il link negli appunti e inviarlo manualmente.",
        "copyLink": "Copia link",
        "regenerateLink": "Rigenera link",
        "regenerateLinkTooltip": "Rigenerando un nuovo link,\nil link attuale perde la sua validità.",
        "deactivateLink": "Disattiva link",
        "deactivateLinkTooltip": "Disattivando il link, esso perderà la sua validità.\nIl destinatario non potrà più accedere all’operazione.",
        "sendLinkByEmail": "Invia link via e-mail",
        "enterEmailHint": "Inserisci l’indirizzo e-mail del destinatario e clicca su Invia.",
        "emailPlaceholder": "Inserisci e-mail del destinatario",
        "resetChanges": "Ripristina tutte le modifiche all’ultimo salvataggio.",
        "inquiryTitle": "Richiesta su",
        "generalInquiry": "Richiesta generale",
        "complaint": "Reclamo",
        "other": "Altro",
        "inquirySent": "La tua richiesta è stata inviata.",
        "operationNumber": "Operazione {number}",
        "operationNotFound": "Operazione {number} non trovata.",
        "position": "Posizione",
        "topic": "Argomento",
        "selectTopic": "Seleziona argomento",
        "message": "Messaggio",
        "submit": "invia",
        "source": "Origine",
        "customerNumber": "N. cliente",
        "orderNumber": "N. ordine",
        "outbound": "Uscita",
        "origin": "Provenienza",
        "numberOfPositions": "N. posizioni",
        "status": "Stato",
        "cancellation": "Annullamento",
        "orderDate": "Data ordine",
        "endCustomer": "Cliente finale",
        "inquiryName": "Richiesta/Nome",
        "inquiryNumber": "N. richiesta",
        "constructionProject": "Progetto di costruzione",
        "commission": "Commissione",
        "constructionSite": "Cantiere",
        "orderContact": "Ordinante",
        "we": "UE",
        "residentialUnits": "Unità abitative",
        "sum": "Totale",
        "inquiry": "Richiesta",
        "inquiryPlace": "Inviare richiesta",
        "inquiryOrder": "Inviare richiesta per l'intero ordine",
        "deliveryAddress": "Indirizzo di consegna",
        "lastUpdatedBy": "Ultima modifica di",
        "openCustomerOrderConfirmation": "Apri conferma ordine cliente",
        "openOriginalOrder": "Apri ordine originale",
        "offerDate": "Data offerta",
        "offerNumber": "N. offerta",
        "openCustomerOffer": "Apri offerta cliente",
        "openOriginalOffer": "Apri offerta originale",
        "inquiryDate": "Data richiesta",
        "duplicateAndEdit": "Duplica <br/> e modifica",
        "head": {
            "origin": "Origine",
            "customerNumber": "N. cliente",
            "offerDate": "Data offerta",
            "orderConfirmationDate": "Data <br/> conferma ordine",
            "offerNr": "N. offerta",
            "orderNr": "N. ordine",
            "source": "Provenienza",
            "openOriginalOffer": "Apri offerta originale",
            "openOriginalOrder": "Apri ordine originale",
            "initialOffer": "Offerta iniziale",
            "noReferenceFound": "Nessun riferimento trovato",
            "amountOfPositions": "N. posizioni",
            "status": "Stato",
            "inquiryDate": "Data richiesta",
            "editedLast": "Ultima modifica <br /> di",
            "clerk": "Responsabile",
            "yourReference": "Tua referenza",
            "constructionProject": "Progetto di costruzione",
            "commission": "Commissione"
        }
    },
    "operationsOut": {
        "entryNotFound": "Voce non trovata.",
        "clickForMoreInfo": "Clicca sulla voce per maggiori informazioni",
        "resetFilter": "Reimposta filtro",
        "filter": "Filtro",
        "tableView": "Vista tabella",
        "gridView": "Vista griglia",
        "orderConfirmation": "Conferma d’ordine",
        "address": {
            "applyPriceGroup": "Applicare il gruppo prezzi?",
            "noPriceGroup": "L’indirizzo non ha un gruppo prezzi assegnato.",
            "resetGlobal": "Vuoi ripristinare il calcolo del prezzo all'impostazione globale?",
            "partnerCompany": "Azienda del referente",
            "selectedAddress": "Indirizzo selezionato",
            "priceGroupApplied": "ha assegnato il gruppo prezzi {priceGroup}, vuoi applicarlo a {documentType}?",
            "currentOffer": "l’offerta attuale",
            "currentOrderConfirmation": "la conferma d’ordine attuale",
            "no": "no",
            "yes": "sì",
            "endCustomerAddress": "Indirizzo del cliente finale",
            "searchInAddressBook": "Cerca nella rubrica",
            "saveData": "Dati salvati"
        }
    },
    "positions": {
        "specialRequestNoCharge": "Richiesta speciale al collaboratore Renz – potrebbe non essere più fatturabile",
        "sequenceNumber": "N. prog.",
        "quantity": "Quantità",
        "unit": "Unità",
        "articleNumber": "Codice articolo",
        "description": "Descrizione",
        "offerNumber": "N. offerta",
        "orderNumber": "N. ordine",
        "position": "Posizione",
        "alternativeTo": "Alternativa a",
        "fileAttachements": "Allegati",
        "linkedIncomingOperations": "Operazioni in entrata collegate",
        "linkedOutgoingOperations": "Operazioni in uscita collegate",
        "texts": "Testi",
        "positionCoverLetter": "Lettera introduttiva posizione",
        "positionsTexts": "Testi posizione",
        "origin": "O.",
        "source": "Origine",
        "customerNumber": "N. cliente",
        "attachement": "Collegamento",
        "amountOfPositions": "N. pos.",
        "status": "Stato",
        "date": "Data",
        "inquiryOrOrderNumber": "N. richiesta/ordine",
        "commission": "Commissione",
        "constructionProject": "Progetto di costruzione",
        "constructionSite": "Cantiere",
        "residentialUnits": "UE",
        "residentialUnitsCountTooltip": "Unità abitative",
        "sum": "Totale",
        "noAttachedOperations": "Nessuna operazione collegata",
        "net": "netto",
        "gross": "lordo",
        "withoutAlternativePositions": "senza posizioni alternative",
        "assemblyInstructionSent": "Le istruzioni di montaggio richieste ti saranno inviate via e-mail e saranno presto disponibili anche su eInfo.",
        "errorOccurred": "Si è verificato un errore! Riprova più tardi.",
        "requestAssemblyInstruction": "Richiedi istruzioni di montaggio",
        "enterEmailPrompt": "Inserisci un indirizzo e-mail al quale inviare le istruzioni di montaggio.",
        "sendAssemblyInstructionTo": "Invia istruzioni di montaggio a",
        "submit": "invia",
        "requestAssemblyInstructionBreak": "Richiedi<br />istruzioni di montaggio",
        "deleteFromOperation": "Elimina dall’operazione",
        "confirmDeletePosition": "Vuoi davvero eliminare la posizione \"<strong>{number}</strong>\" dall’operazione?",
        "deleteOperation": "Elimina operazione",
        "confirmDeleteLastPosition": "Questa è l’ultima posizione. Sei sicuro di voler eliminare l’intera operazione dal carrello?",
        "restorePosition": "Ripristina posizione",
        "confirmRestorePosition": "Vuoi davvero ripristinare la posizione \"<strong>{number}</strong>\"?",
        "marginWarning": "Il tuo prezzo di vendita è inferiore al prezzo d’acquisto.",
        "image": "Immagine",
        "positionShort": "Pos.",
        "quantityShort": "Qtà",
        "chargeable": "fatturabile",
        "productGroup": "Gruppo prodotto",
        "modelGroup": "Gruppo modello",
        "color": "Colore",
        "cancellation": "Annullamento",
        "noCancellation": "Nessun annullamento",
        "deliveryDateFromFactory": "Data consegna da stabilimento",
        "tracking": "Tracciamento pacco",
        "ecpNumber": "Numero ECP",
        "residentialUnitsShort": "UE",
        "infoToAgent": "Info al responsabile",
        "unitPrice": "Prezzo unitario",
        "actions": "Azioni",
        "packagingAndShipping": "Imballaggio e spedizione",
        "packagingAndShippingDescription": "Questo importo viene addebitato per imballaggio e spedizione.",
        "noPreviousEntry": "Nessuna voce precedente",
        "alternativeToPosition": "Alternativa alla posizione {number}",
        "previousValue": "valore precedente",
        "amount": "Quantità",
        "sellingPrice": "Prezzo di vendita",
        "purchasePrice": "Prezzo d'acquisto",
        "showPositionDetails": "Mostra dettagli della posizione.",
        "inquiry": "Richiesta",
        "inquiryForPosition": "Richiedi informazioni su questa posizione",
        "deletePosition": "Elimina posizione",
        "delete": "elimina",
        "recreate": "Ripristina",
        "recreatePosition": "Ripristina posizione",
        "noColorSpecification": "nessuna specifica di colore",
        "addAdditionalService": "Aggiungi servizio aggiuntivo",
        "RRP": "Prezzo consigliato",
        "endcustomer": "Cliente finale",
        "margin": "Margine"
    },
    "priceCalculation": {
        "priceCalculation": "Calcolo del prezzo",
        "globalPricegroup": "Gruppo prezzi globale",
        "dealerNr": "N. rivenditore",
        "manualInput": "Inserimento manuale"
    },
    "address": {
        "deliveryEqualsCompany": "l'indirizzo di consegna è uguale all'indirizzo aziendale",
        "deliveryUnequalsCompany": "l'indirizzo di consegna è diverso dall'indirizzo aziendale",
        "customerNumberAlreadyTaken": "Il numero cliente è già assegnato.",
        "decideCompAndShipAddress": "Decidi se l’indirizzo aziendale è uguale all’indirizzo di consegna.",
        "fillOutMandatoryFields": "Compila tutti i campi obbligatori!",
        "editAddress": "Modifica indirizzo",
        "addPersonSuccess": "Contatto aggiunto con successo.",
        "addAddressSuccess": "Nuovo indirizzo creato con successo.",
        "addPersonError": "Errore durante la creazione del contatto.",
        "addAddressError": "Errore durante la creazione dell’indirizzo.",
        "closeAddress": "Chiudi indirizzo",
        "unsavedChanges": "Hai modifiche non salvate. Vuoi davvero chiudere il modulo?",
        "addressBook": "Rubrica",
        "contactPerson": "Referente",
        "firstName": "Nome",
        "lastName": "Cognome",
        "companyName": "Nome azienda",
        "vatId": "Partita IVA",
        "company2OrAdditionalAddress": "Azienda 2 / indirizzo aggiuntivo",
        "noChangeToGlobalTaxRate": "Nessuna modifica all’aliquota IVA globale",
        "postalCode": "CAP",
        "vat": "IVA",
        "phone": "Telefono",
        "paymentTerms": "Condizioni di pagamento",
        "fax": "Fax",
        "email": "E-mail",
        "website": "Sito web",
        "contactPersonName": "REFERENTE (COGNOME, NOME)",
        "assignedPriceGroup": "Gruppo prezzi assegnato",
        "contactPersonSalutation": "TITOLO REFERENTE",
        "edit": "Modifica indirizzo",
        "delete": "Elimina indirizzo",
        "createSuccess": "Nuovo indirizzo creato con successo.",
        "createError": "Errore durante la creazione dell’indirizzo.",
        "freeSearch": "Ricerca libera",
        "enterSearchTerm": "Inserisci termine di ricerca",
        "type": "Tipo",
        "company": "Azienda",
        "salutation": "Titolo",
        "firstname": "Nome",
        "lastname": "Cognome",
        "street": "Via",
        "houseNumber": "N. civico",
        "supplement": "Supplemento indirizzo",
        "postcode": "CAP",
        "city": "Città",
        "country": "Paese",
        "customerNumber": "N. cliente",
        "typeTooltipCompany": "Azienda",
        "typeTooltipContactPerson": "Referente",
        "setNewAddress": "Crea nuovo indirizzo",
        "setNewEntry": "Crea nuova voce",
        "entry": "record",
        "editEntry": "Modifica voce",
        "deleteContact": "Elimina contatto",
        "saveData": "Dati salvati",
        "reset": "⟳ reimposta",
        "notModified": "L’indirizzo non è stato modificato.",
        "closeHeader": "Chiudi indirizzo",
        "unsavedChangesWarning": "Hai modifiche non salvate. Vuoi davvero chiudere il modulo?",
        "contactDeletedSuccess": "Contatto eliminato con successo.",
        "resetChangesInfo": "Tutte le modifiche verranno annullate e ripristinate all’ultimo salvataggio.",
        "deleteError": "L’indirizzo non può essere eliminato!",
        "multipleDeleteSuccess": "{successfulDeletes} contatti e un indirizzo sono stati eliminati con successo.",
        "partialDeleteError": "Alcuni indirizzi non possono essere eliminati!",
        "unexpectedError": "Si è verificato un errore imprevisto!",
        "removeContactHeader": "Rimuovi referente",
        "deleteEntryHeader": "Elimina voce",
        "removeContactConfirm": "Vuoi davvero rimuovere il referente?",
        "deleteContactConfirm": "Vuoi davvero eliminare il contatto dalla rubrica? Verranno eliminati anche tutti i referenti assegnati.",
        "cancelButton": "annulla",
        "removeButton": "rimuovi",
        "deleteButton": "elimina",
        "customerNumberLabel": "(N. cliente: {customerNumber})",
        "dealerNumberLabel": "(N. rivenditore: {dealerNumber})",
        "dealerNr": "N. rivenditore",
        "manualEntry": "Inserimento manuale",
        "newContact": "Nuovo referente",
        "fillRequiredFields": "Compila tutti i campi obbligatori!"
    },
    "components": {
        "additionalServices": {
            "addService": "Aggiungi servizio aggiuntivo",
            "deleteService": "Elimina servizio aggiuntivo",
            "amount": "Quantità",
            "service": "Servizio",
            "description": "Descrizione",
            "price": "Prezzo (€)",
            "salesPrice": "Prezzo di vendita:",
            "serviceToPosition": "Servizio alla posizione"
        },
        "additionalPosition": {
            "additionalPosition": "Posizione aggiuntiva",
            "headingInPdf": "Intestazione nel PDF",
            "addAdditionalPosition": "Aggiungi posizione aggiuntiva",
            "additionalPositionAdd": "Aggiungere posizione aggiuntiva"
        },
        "operationsEmail": {
            "recipient": "Destinatario",
            "cc": "CC",
            "bcc": "BCC",
            "subject": "Oggetto",
            "message": "Messaggio",
            "sendOfferSubject": "Offerta cliente {number}",
            "sendOrderConfirmationSubject": "Conferma d’ordine {number}",
            "sendOfferMessage": "Gentile cliente,\nin allegato trova l’offerta non vincolante relativa alle posizioni richieste.\n\nCordiali saluti,\n{firstName} {lastName} ({email})",
            "sendOrderConfirmationMessage": "Gentile cliente,\nin allegato trova la conferma d’ordine.\n\nCordiali saluti,\n{firstName} {lastName} ({email})",
            "attachment": "Allegato",
            "sendButton": "Invia",
            "offerSentNotification": "L’offerta è stata inviata.",
            "orderConfirmationSentNotification": "La conferma d’ordine è stata inviata.",
            "errorNotification": "Si è verificato un errore. Riprova più tardi.",
            "offerCouldNotBeSent": "L’offerta non può essere salvata"
        },
        "operationDetails": {
            "manualPriceGroup": "Inserimento manuale",
            "globalPriceGroup": "Gruppo prezzi globale",
            "dealerNumber": "N. rivenditore",
            "offerTemplate": "Modello offerta",
            "orderConfirmationTemplate": "Modello conferma d’ordine",
            "couldNotBeCreated": " non può essere creato",
            "offer": "Offerta",
            "orderConfirmation": "Conferma d’ordine",
            "isNotCompleted": " non è ancora completato. Verifica se è stato assegnato un modello valido.",
            "wasSuccessfullySaved": " è stato salvato con successo.",
            "offerCouldNotBeSaved": "L’offerta non può essere salvata",
            "wasSuccessfullyCreated": " è stato creato con successo.",
            "saveToGeneratePDF": "Salva il documento per generare il PDF.",
            "selectAtLeastOnePosition": "Seleziona almeno una posizione",
            "markedPositionsToCart": "posizioni selezionate nel carrello",
            "convertToCustomerOffer": "in offerta cliente",
            "convertToOrderConfirmation": "in conferma d’ordine",
            "transformTo": "trasforma in",
            "sendOfferToCustomer": "Invia offerta <br /> al cliente",
            "createOrderConfirmationAndEdit": "Crea conferma d’ordine <br /> e modifica",
            "sendOrderConfirmationToCustomer": "Invia conferma d’ordine <br /> al cliente",
            "offerChanged": "L’offerta è stata modificata, salva per continuare!",
            "noCorrespondingOrder": "Nessun ordine corrispondente disponibile. Attendi che l’ordine sia disponibile nel sistema Renz!",
            "orderCanceled": "L’ordine è stato annullato.",
            "allPositionsCanceled": "Tutte le posizioni rilevanti dell’ordine sono state annullate.",
            "orderConfirmationChanged": "La conferma d’ordine è stata modificata, salva per continuare!",
            "orderConfirmationNotComplete": "La conferma d’ordine non è ancora completata.",
            "offerAlreadySent": "L’offerta è già stata inviata al cliente",
            "orderConfirmationAlreadySent": "La conferma d’ordine è già stata inviata al cliente",
            "orderConfirmationTemplateError": "Errore nella creazione del modello della conferma d’ordine: ",
            "offerNotChanged": "L’offerta non è stata modificata!",
            "orderConfirmationNotChanged": "La conferma d’ordine non è stata modificata!",
            "offerReset": "Ripristina l’offerta all’ultimo stato salvato",
            "orderConfirmationReset": "Ripristina la conferma d’ordine all’ultimo stato salvato",
            "orderNotComplete": "L’ordine non è ancora completato.",
            "offerNotCompleted": "L’offerta non è ancora completata. Verifica la presenza del PDF. Se manca, controlla il modello e salva di nuovo.",
            "templateNotAvailable": "Nessun modello trovato né per il numero rivenditore né per te.",
            "offerDataInherited": "Le impostazioni delle offerte di origine delle posizioni sono state ereditate.",
            "invalid": "non valido",
            "dataFromIncomingOrder": "I dati dell’ordine in entrata vengono utilizzati."
        },
        "table": {
            "changesInOperations": "Modifiche nel processo",
            "fieldName": "Nome del campo",
            "previousValue": "Valore precedente",
            "currentValue": "Valore attuale",
            "watchlist": "Lista preferiti",
            "offerNumber": "Numero offerta",
            "transationStemsFrom": "L’operazione proviene da un’offerta iniziale",
            "offerGotChanged": "L’offerta {offerNumber} è stata modificata esternamente, viene mostrata la versione aggiornata.",
            "noCurrentEntry": "Nessuna voce attuale",
            "noEarlierEntry": "Nessuna voce precedente",
            "fields": {
                "attachmentField": {
                    "offer": "Offerta",
                    "orderConfirmation": "Conferma d’ordine",
                    "invoice": "Fattura",
                    "deliveryNote": "Bolla di consegna",
                    "twoDOverall": "Immagine 2D complessiva",
                    "twoDDetail1": "Dettaglio 2D 1",
                    "twoDDetail2": "Dettaglio 2D 2",
                    "twoDImage": "Immagine 2D",
                    "threeDImage": "Immagine 3D",
                    "assemblyInstruction": "Istruzioni di montaggio",
                    "dxfFile": "File DXF"
                },
                "cancellation": {
                    "none": "nessuna cancellazione",
                    "full": "tutte le posizioni annullate",
                    "partial": "cancellazione parziale"
                },
                "trackingList": {
                    "delivered": "consegnato",
                    "inDelivery": "in consegna",
                    "inTransit": "in transito",
                    "noData": "nessun dato disponibile",
                    "externalLink": "link esterno a {shippingCompany}",
                    "noTrackingLink": "nessun link di tracciamento disponibile",
                    "shippingCompany": "Corriere: {shippingCompany}",
                    "receipt": "Ricevuta: {receiver}"
                },
                "trackingField": {
                    "trackingLabel": "Tracciamento pacco",
                    "deliveredStatus": "{deliveredCount} di {count} consegnati",
                    "showDetails": "Mostra dettagli",
                    "notAvailable": "non disponibile"
                },
                "status": {
                    "orderConfirmation": "Conferma d’ordine",
                    "shipping": "Spedizione",
                    "manufacture": "Produzione",
                    "offerCreated": "Offerta creata",
                    "offerInProgress": "Offerta in lavorazione",
                    "offerEmailSent": "Email offerta inviata {emailDetails}",
                    "noOfferEmailSent": "Nessuna email offerta inviata",
                    "emailDetails": "ultimo invio a {recipient} il {timestamp}",
                    "orderConfirmationEmailSent": "Email conferma d’ordine inviata {emailDetails}",
                    "noOrderConfirmationEmailSent": "Nessuna email conferma d’ordine inviata",
                    "inConfirmCount": "{count} posizione(i) in elaborazione",
                    "orderConfirmed": "Ordine confermato",
                    "orderInProgress": "Ordine in elaborazione",
                    "objectionPeriod": "Periodo di opposizione",
                    "inObjectionPeriod": "{count} posizione(i) in periodo di opposizione",
                    "objectionPeriodExpiredForSome": "Periodo di opposizione scaduto per {count} posizione(i)",
                    "objectionPeriodExpired": "Periodo di opposizione scaduto",
                    "objectionPeriodAfterConfirmation": "Periodo di opposizione inizia dopo la conferma d’ordine",
                    "inManufacture": "{count} posizione(i) in produzione",
                    "manufactureCompleted": "Produzione completata",
                    "noItemsInManufacture": "nessuna posizione in produzione",
                    "inReadyToShip": "{count} posizione(i) pronte per la spedizione",
                    "readyToShipCompleted": "Preparazione alla spedizione completata",
                    "noItemsReadyToShip": "nessuna posizione pronta alla spedizione",
                    "inShipment": "{count} posizione(i) spedite",
                    "delivered": "{count} posizione(i) consegnate",
                    "noItemsInShipment": "nessuna posizione in consegna",
                    "missingTracking": "Mancano informazioni complete sul tracking.",
                    "orderedMultiple": "Ordinato {count} volta/e.",
                    "notOrdered": "Non ancora ordinato.",
                    "fullyOrdered": "completamente ordinato",
                    "orderedCount": "{count} posizione(i) ordinate",
                    "outboundOfferCreated": "Offerta in uscita creata",
                    "noOutboundOfferCreated": "nessuna offerta in uscita creata",
                    "orderConfirmationCreated": "Conferma d’ordine creata",
                    "noOrderConfirmationCreated": "nessuna conferma d’ordine creata",
                    "operationStatusUpdated": "Lo stato dell’operazione {operationNumber} è stato impostato su {statusLabel} e la nota è stata aggiornata.",
                    "operationStatusOnlyUpdated": "Lo stato dell’operazione {operationNumber} è stato impostato su {statusLabel}.",
                    "operationNoteUpdated": "La nota dell’operazione {operationNumber} è stata aggiornata.",
                    "noPermissionToEditStatus": "Non hai i permessi per modificare lo stato",
                    "defaultFirstName": "Il mio nome",
                    "defaultLastName": "Il mio cognome",
                    "operationTracking": "Tracciamento dell’operazione {operationNumber}",
                    "status": "Stato",
                    "notes": "Note",
                    "insertTimestampLine": "Inserisci riga con timestamp",
                    "noNotesAvailable": "Nessuna nota disponibile",
                    "clickIconToMakeChanges": "Clicca sull’icona per apportare modifiche",
                    "inObjectionPeriodUntil": "Posizione in periodo di opposizione fino al {date}",
                    "objectionPeriodExpiredOn": "Periodo di opposizione scaduto {dateInfo}",
                    "dateOn": " il {date}",
                    "positionInManufacture": "Posizione in produzione",
                    "manufactureNotStarted": "Produzione non ancora iniziata",
                    "positionDelivered": "Posizione consegnata",
                    "positionShippedNoTracking": "Posizione spedita\n\nNessuna informazione di tracking disponibile.",
                    "positionShipped": "Posizione spedita",
                    "positionNotShipped": "Posizione non ancora spedita",
                    "positionReadyToShip": "Posizione pronta per la spedizione",
                    "noPositionsInShipping": "nessuna posizione in spedizione"
                },
                "number": {
                    "offerNumber": "Offerta / Numero {operationNumber}",
                    "orderNumber": "Ordine / Numero {operationNumber}",
                    "positionNumber": "\nPosizione {positionNumber}"
                },
                "chargeableField": {
                    "CAD": "Posizione ora è CAD speciale",
                    "NTF": "Posizione è NettoFix",
                    "BTF": "Posizione è LordoFix",
                    "GNE": "Motivo non identificabile",
                    "CPY": "Valore iniziale durante la copia nel BO",
                    "SBE": "Inserita successivamente dal responsabile",
                    "BNI": "Chiarimento con responsabile Renz",
                    "BNA": "Bonus disattivato a livello principale → non rimborsabile",
                    "SW": "Cliente ha indicato una richiesta speciale",
                    "SBO": "Modifica successiva dal responsabile",
                    "SBA": "Modifica successiva dal responsabile",
                    "SBR": "Revoca per modifica manuale degli sconti",
                    "SHO": "Inserimento tramite eConfig",
                    "WVU": "Transazione tra aziende collegate",
                    "QNR": "Ordine RIT – fonte non rimborsabile RIK",
                    "chargeable": "La posizione è rimborsabile.",
                    "notChargeable": "La posizione non è rimborsabile",
                    "reason": "\n\n{reason}",
                    "notChargeableOperation": "Operazione non rimborsabile. {reasonsText}",
                    "partiallyChargeable": "{chargeableCount} su {totalCount} posizioni sono rimborsabili. {reasonsText}",
                    "fullyChargeable": "Tutte le posizioni dell’operazione sono rimborsabili"
                }
            }
        },
        "priceWizard": {
            "priceWizard": "Assistente prezzi",
            "showPricewizard": "Mostra assistente prezzi",
            "applyConfirmation": "Conferma applicazione",
            "applyPriceGroupPrompt": "Vuoi applicare il gruppo prezzi all’intera operazione o solo a questa posizione?",
            "applyRestricted": "applica alla posizione",
            "applyEntireOperation": "applica all’intera operazione",
            "applyMarginWarning": "Il tuo prezzo di vendita è inferiore al prezzo d’acquisto. Vuoi davvero continuare?",
            "resetConfirmation": "Tutte le modifiche verranno ripristinate all’ultimo salvataggio.",
            "priceGroupNotModified": "Il gruppo prezzi non è stato modificato.",
            "sellingPrice": "Prezzo di vendita",
            "inputInEUR": "Inserimento in EUR",
            "additionalPositionNumber": "N. posizione aggiuntiva",
            "quantity": "Quantità pos.",
            "RRP": "Prezzo consigliato",
            "sale": "Sconto",
            "discount": "Sconto",
            "inputInPercent": "Inserimento in %",
            "specificationInEur": "Specificazione in EUR",
            "subtotal": "Subtotale",
            "surcharge": "Supplemento",
            "currentPurchasePrice": "Prezzo d’acquisto attuale",
            "difference": "Differenza",
            "originalPurchasePrice": "Prezzo d’acquisto originale",
            "basisForCalculations": "(Base per i calcoli)",
            "purchasePrice": "Prezzo d’acquisto",
            "entirePriceGroup": "Intero gruppo prezzi",
            "selectPriceGroup": "Seleziona gruppo prezzi",
            "showDiscountPDFs": "Mostra sconto nei PDF dell’offerta e della conferma d’ordine",
            "costType": "Tipo di costo",
            "net": "Netto",
            "gross": "Lordo",
            "percentageInput": "Inserimento in %",
            "closeIcon": "Chiudi",
            "searchIcon": "Cerca",
            "editEndcustomerAddress": "Modifica indirizzo cliente finale"
        },
        "richtext": {
            "bold": "Grassetto",
            "italic": "Corsivo",
            "underline": "Sottolineato",
            "strike": "Barrato",
            "align": "Allineamento",
            "blockquote": "Citazione",
            "code_block": "Codice",
            "list": "Elenco",
            "color": "Colore testo",
            "background": "Colore sfondo",
            "image": "Inserisci immagine",
            "link": "Inserisci link",
            "clean": "Rimuovi formattazione",
            "priceGroupNotModified": "Il gruppo prezzi non è stato modificato."
        },
        "datepicker": {
            "days": [
                "Domenica",
                "Lunedì",
                "Martedì",
                "Mercoledì",
                "Giovedì",
                "Venerdì",
                "Sabato"
            ],
            "daysShort": [
                "Dom",
                "Lun",
                "Mar",
                "Mer",
                "Gio",
                "Ven",
                "Sab"
            ],
            "daysMin": [
                "Do",
                "Lu",
                "Ma",
                "Me",
                "Gi",
                "Ve",
                "Sa"
            ],
            "months": [
                "Gennaio",
                "Febbraio",
                "Marzo",
                "Aprile",
                "Maggio",
                "Giugno",
                "Luglio",
                "Agosto",
                "Settembre",
                "Ottobre",
                "Novembre",
                "Dicembre"
            ],
            "monthsShort": [
                "Gen",
                "Feb",
                "Mar",
                "Apr",
                "Mag",
                "Giu",
                "Lug",
                "Ago",
                "Set",
                "Ott",
                "Nov",
                "Dic"
            ],
            "today": "Oggi",
            "clear": "Cancella",
            "titleFormat": "MM y",
            "format": "dd.mm.yyyy"
        },
        "overlay": {
            "closeOffer": "Chiudi offerta",
            "unsavedChanges": "Hai modifiche non salvate. Vuoi davvero chiudere l’offerta?"
        },
        "followUp": {
            "removeResubmissionDate": "Rimuovi data di promemoria",
            "setResubmissionDate": "Imposta data di promemoria",
            "onlyEditResubmissions": "Puoi modificare solo i tuoi promemoria."
        },
        "documentTemplate": {
            "template": "Modello",
            "offerTemplate": "Modello offerta",
            "orderConfirmationTemplate": "Modello conferma d’ordine",
            "offerTemplateGotSaved": "Il modello dell’offerta è stato salvato con successo.",
            "filesAllowed": "Sono consentiti solo file png e jpg/jpeg.",
            "resetToDefault": "Ripristina impostazioni predefinite",
            "letterPaper": "Carta intestata",
            "defineLayoutThroughBGImages": "Definire layout tramite immagine di sfondo",
            "defineLayoutThroughLogo": "Definire layout tramite logo",
            "logoPosition": "Posizione del logo",
            "verticalOrientation": "Allineamento verticale",
            "horizontalOrientation": "Allineamento orizzontale",
            "verticalDisplacement": "Spostamento verticale",
            "horizontalDisplacement": "Spostamento orizzontale",
            "noLogoAvailable": "Nessun logo disponibile",
            "deleteFile": "Elimina file",
            "footer": "Piè di pagina",
            "noFooterAvailable": "Nessun piè di pagina disponibile",
            "firstPage": "Prima pagina",
            "noTemplateAvailable": "Nessun modello disponibile",
            "templateNotModified": "Il modello non è stato modificato.",
            "subsequentPages": "Pagine successive",
            "margins": "Margini",
            "top": "Alto",
            "right": "Destra",
            "bottom": "Basso",
            "left": "Sinistra",
            "forSubsequentPages": "per le pagine successive",
            "preview": "Anteprima",
            "mandatoryField": "Campo obbligatorio",
            "textContent": "Contenuti testuali",
            "contact": "Referente",
            "defaultContactPerson": "Per impostazione predefinita viene utilizzato l’utente connesso come referente. Questo può essere disattivato nella sezione \"Modifica modello\".",
            "displayedContactPerson": "Referente visualizzato nell’intestazione del modello*",
            "eMailOfContact": "E-mail del referente*",
            "useLoggedInUserAsContact": "Utilizzare utente connesso come referente.",
            "telephoneOfContact": "Telefono del referente*",
            "currentLoggedInUser": "Utente attualmente connesso:",
            "emailContent": "Testo e-mail",
            "emailSubject": "Oggetto e-mail*",
            "subjectLine": "Questo è un oggetto",
            "emailBody": "Testo dell’e-mail",
            "pdfContent": "Testi PDF",
            "introductionText": "Testo introduttivo",
            "introContent": "Qui va il testo introduttivo",
            "originalCoverLetter": "Lettera introduttiva originale",
            "closingNote": "Nota di chiusura (verrà mostrata dopo l’elenco delle posizioni)",
            "closingText": "Qui va il testo di chiusura",
            "coverLetter": "Lettera introduttiva",
            "deliveryTimeAndPaymentTerms": "Tempi di consegna e condizioni di pagamento*",
            "deliveryTime": "Tempo di consegna",
            "paymentTermsDescription": "Descrizione delle condizioni di pagamento",
            "emailBodyPlaceholder": "Qui va il testo della mail",
            "paymentTerms": "Condizioni di pagamento*",
            "editTemplate": "Modifica modello"
        },
        "pcalc": {
            "originType": "Tipo di origine",
            "uvp": "Prezzo consigliato (UVP)",
            "markupOnPurchasePrice": "Margine sul prezzo d’acquisto",
            "discountOnRRP": "Sconto sul prezzo consigliato",
            "minMarginOnPurchasePrice": "Margine minimo sul prezzo d’acquisto",
            "addPriceGroup": "Aggiungi gruppo prezzi",
            "priceCalculation": "Calcolo del prezzo",
            "globalPriceCalculation": "Calcolo del prezzo globale",
            "priceGroups": "Gruppi prezzi",
            "updateSuccess": "Le modifiche sono state aggiornate con successo.",
            "updateError": "Le modifiche non possono essere salvate.",
            "createSuccess": "Il calcolo dei prezzi è stato salvato con successo.",
            "createError": "Il calcolo dei prezzi non può essere salvato.",
            "deleteSuccess": "Il calcolo dei prezzi è stato eliminato con successo.",
            "deleteError": "Il calcolo dei prezzi non può essere eliminato.",
            "defaultCalculation": "Calcolo predefinito",
            "groupNamePlaceholder": "Nome del gruppo",
            "editGroupName": "Modifica nome del gruppo",
            "deleteGroup": "Elimina gruppo",
            "resetTooltip": "Tutte le modifiche verranno ripristinate all’ultimo salvataggio.",
            "reset": "ripristina",
            "invalid": "Non valido",
            "notModified": "Il gruppo prezzi non è stato modificato.",
            "validity": "Validità",
            "daysValidPlaceholder": "es. 14",
            "days": "Giorni",
            "fixedDates": "Date fisse",
            "datePlaceholder": "Da",
            "internalComment": "Commento interno",
            "commentNote": "(non appare in nessun documento stampato)",
            "commentPlaceholder": "Il tuo commento sulla data",
            "addFixedDate": "Aggiungi data fissa",
            "exceptionRule": "Regola d’eccezione",
            "exceptionRules": "Regole d’eccezione",
            "youCanIndivualize": "Puoi personalizzare il calcolo tramite i campi “Attributo”, “Operatore di confronto” e “Cerca valore” (può essere selezionato più di un valore).",
            "processedTopBottom": "Le regole vengono applicate dall’alto verso il basso.",
            "filter": "Filtro",
            "addExceptionRule": "Aggiungi regola d’eccezione",
            "exceptionRuleTitle": "Titolo regola d’eccezione",
            "removeFilter": "Rimuovi filtro",
            "comparisonOperator": "Operatore di confronto",
            "installationType": "Tipo d’installazione",
            "netPrice": "Prezzo netto",
            "residentialUnitsCount": "Unità abitative",
            "residentialUnitsCountTotal": "Totale unità abitative",
            "productGroup": "Gruppo prodotto",
            "modelGroup": "Gruppo modello",
            "equalsExample": "Uguale (es. 5 = 5)",
            "notEqualsExample": "Diverso (es. 5 ≠ 3)",
            "greaterExample": "Maggiore (es. 5 > 3)",
            "lessExample": "Minore (es. 3 < 5)",
            "greaterOrEqualExample": "Maggiore o uguale (es. 5 ≥ 5)",
            "lessOrEqualExample": "Minore o uguale (es. 3 ≤ 5)",
            "attribute": "Attributo"
        },
        "pcalcGroup": {
            "priceGroup": "Gruppo prezzi",
            "globalPriceGroup": "Gruppo prezzi globale",
            "dealerNr": "N. rivenditore",
            "selectPriceGroup": "Seleziona gruppo prezzi",
            "manualInput": "Inserimento manuale",
            "activePriceGroup": "Gruppo prezzi attivo",
            "changePriceGroup": "Modifica gruppo prezzi",
            "applyPriceGroup": "Applica gruppo prezzi",
            "inclusive": "incl.",
            "vat": "IVA",
            "gotApplied": "Il gruppo prezzi è stato applicato con successo."
        },
        "noOffer": "Nessuna offerta",
        "operationsFilter": {
            "all": "tutti",
            "taskSent": "Conferma d’ordine inviata",
            "offerSent": "Offerta inviata",
            "allSources": "Tutte le fonti",
            "user_status": "Stato utente",
            "internal_status": "Stato interno",
            "undefined": "Tutti gli stati",
            "inProgress": "in elaborazione",
            "created": "Offerta creata",
            "outOfferCreated": "Offerta in uscita creata",
            "ordered": "ordinato",
            "open_dealer": "aperto",
            "lost_dealer": "perso",
            "won_dealer": "vinto",
            "waitingForResponse_dealer": "in attesa di risposta",
            "followup_dealer": "promemoria",
            "locked_dealer": "bloccato",
            "open_internal": "aperto",
            "lost_internal": "perso",
            "won_internal": "vinto",
            "waitingForResponse_internal": "in attesa di risposta",
            "followup_internal": "promemoria",
            "locked_internal": "bloccato",
            "confirmed": "conferma d’ordine",
            "inObjectionPeriod": "in periodo di opposizione",
            "delayed": "in ritardo",
            "manufactured": "in produzione",
            "readyToShip": "pronto per la spedizione",
            "inShipment": "spedito",
            "delivered": "consegnato",
            "canceled": "annullato",
            "applyFilter": "Applica filtro",
            "resetFilter": "Reimposta filtro",
            "agent": "Responsabile",
            "selectAgent": "Seleziona responsabile",
            "representative1": "Rappresentante 1",
            "selectRepresentative": "Seleziona rappresentante",
            "selectModelGroup": "Seleziona gruppo modello",
            "modelGroup": "Gruppo modello",
            "installationType": "Tipo di montaggio",
            "selectInstallationType": "Seleziona tipo di montaggio",
            "residentialUnits": "Unità abitative",
            "unitPrice": "Prezzo unitario",
            "advancedSearch": "Ricerca avanzata",
            "dealerCustomers": "Clienti del rivenditore",
            "enterNumberOrName": "Inserisci numero / nome",
            "until": "fino al",
            "filterTimeRange": "Filtra per periodo",
            "from": "da",
            "freeSearch": "Ricerca libera",
            "origin": "Origine",
            "selectOrigin": "Seleziona origine",
            "selectStatus": "Seleziona stato",
            "status": "Stato",
            "filter": "Filtro"
        },
        "operationProtocol": {
            "protocolForOffer": "Protocollo per offerta {number}",
            "noProtocol": "Questa offerta non ha ancora alcun protocollo.",
            "timestamp": "Data e ora",
            "action": "Operazione",
            "editor": "Modificato da",
            "details": "Dettagli",
            "legend": "Legenda",
            "emailSent": "Email inviata",
            "added": "Aggiunto",
            "created": "Creato",
            "edited": "Modificato",
            "close": "Chiudi",
            "protocol": "Protocollo",
            "operationChanges": "Modifiche all’operazione",
            "fieldName": "Nome campo",
            "previousValue": "Valore precedente",
            "currentValue": "Valore attuale",
            "noPreviousEntry": "Nessuna voce precedente",
            "noCurrentEntry": "Nessuna voce attuale",
            "creationOrderConfirmation": "creazione della conferma d'ordine",
            "creationOffer": "creazione dell'offerta",
            "processingOrderConfirmation": "elaborazione della conferma d'ordine",
            "processingOffer": "elaborazione dell'offerta"
        },
        "date": {
            "dateDeleteValidationModal": {
                "question": "Vuoi davvero rimuovere la data?",
                "cancelButton": "annulla",
                "deleteButton": "sì"
            },
            "followUpDeleteValidationModal": {
                "question": "Vuoi davvero rimuovere l’operazione dalla lista dei preferiti?",
                "cancelButton": "annulla",
                "deleteButton": "sì"
            }
        }
    },
    "config": {
        "open": "Aperto",
        "lost": "Perso",
        "won": "Vinto",
        "locked": "Bloccato",
        "waitingForResponse": "In attesa di risposta",
        "followup": "Promemoria",
        "country": {
            "DE": "Germania",
            "AT": "Austria",
            "SE": "Svezia",
            "LU": "Lussemburgo",
            "BE": "Belgio"
        },
        "hints": {
            "placeholderHint": "Puoi inserire i seguenti segnaposto:<br />[Numero]<br />[Azienda]<br />[Nome]<br />[Cognome]<br />[Progetto di costruzione]<br />[Commissione]",
            "imageFormatHint": "Il formato dell’immagine deve essere .jpg o .png. La risoluzione ottimale è 2480x3508 pixel. Sono possibili anche altre dimensioni, ma la qualità potrebbe risentirne.",
            "imageSimpleFormatHint": "Il formato dell’immagine deve essere .jpg o .png. La risoluzione ottimale per il logo è 1240x680 pixel. Per il piè di pagina è 2480x240 pixel con un’altezza di circa 3 cm. Anche altre dimensioni sono possibili, ma la qualità può risultare compromessa."
        },
        "shippingCompanies": {
            "1003": "DPD",
            "1004": "Spedizione Kirchberg/Murr",
            "1005": "Spedizione Häring",
            "1006": "Spedizione Kunzendorf",
            "1007": "Spedizione Franz Lerner GmbH",
            "1010": "Elmar Maurus Logistic",
            "1011": "Spedizione Ulmschneider",
            "1012": "DHL Freight GmbH",
            "1013": "Spedizione Weckerle",
            "1014": "Spedizione H. v. Wirth",
            "1017": "UPS",
            "1023": "Spedizione Redemann",
            "1032": "Spedizione Dachser",
            "1044": "Trasporti Gert Treitinger",
            "1045": "Spedizione Rentschler",
            "1046": "DSV Stoccarda",
            "1047": "TNT",
            "1048": "Spedizione Dischinger Ebersbach",
            "1049": "Spedizione Atege",
            "1051": "Spedizione Schmalz + Schön",
            "1053": "Spedizione SCS Stuttgart GmbH",
            "1054": "Spedizione L.W.Cretschmar GmbH & Co. KG",
            "1055": "Spedizione Trautwein",
            "1056": "Spedizione L. Wackler Wwe. Nachf. GmbH",
            "1057": "Spedizione Dacotrans Grosskopf GmbH & Co. KG",
            "1058": "Ebenroth - Logistica pura",
            "1059": "HTL-Peter Messner GmbH / Commercio-Trasporto-Logistica",
            "1060": "Kunzendorf Sped. GmbH / Filiale Schkeuditz",
            "1061": "Spedizione ROHLIG SUUS Logistics SA",
            "1062": "Optimal Kurier",
            "1063": "Heppner Internationale / Spedizione GmbH & Co. KG",
            "1064": "DACHSER SE Spedizione",
            "1065": "Renz Francia in FR Spedizione",
            "1066": "Renz Polonia in PL Spedizione",
            "1067": "Inotherm in SI Spedizione",
            "1068": "Kühne + Nagel"
        },
        "operationSources": {
            "10": {
                "label": "Back Office"
            },
            "20": {
                "label": "eConfig Pro"
            },
            "30": {
                "label": "eConfig"
            },
            "40": {
                "label": "RIT"
            },
            "50": {
                "label": "eShop"
            },
            "60": {
                "label": "eInfo"
            }
        },
        "installationTypeCodes": {
            "1": "Montaggio a incasso / a parete parziale",
            "2": "Montaggio a parete",
            "3": "Montaggio autoportante, prelievo frontale",
            "4": "Montaggio autoportante, prelievo posteriore",
            "5": "Montaggio passante attraverso muro",
            "6": "Montaggio su recinzione",
            "7": "Montaggio laterale porta, prelievo posteriore",
            "8": "Colonnina di contatto",
            "9": "Passaggio muro con cassette orizzontali",
            "10": "Montaggio singolo",
            "11": "Montaggio laterale porta, prelievo frontale",
            "12": "Porte/sportelli/alloggiamenti di ricambio",
            "13": "Frontali personalizzati",
            "14": "Passaggio muro (solo Svizzera)"
        },
        "productGroupCodes": {
            "1": "Renz",
            "2": "Startline",
            "3": "Renz Plan"
        },
        "modelGroupCodes": {
            "10": "Cassette verticali, prelievo frontale",
            "12": "Cassette porta laterali, prelievo posteriore",
            "13": "Cassette orizzontali, prelievo frontale",
            "14": "Montaggio a muro, prelievo posteriore",
            "15": "Linea Commercial / Linea Privata",
            "16": "Citofoni / Campanelli",
            "17": "Cassette da recinzione / Componenti singoli",
            "20": "Impianti di deposito",
            "21": "Distribuzione posta passante",
            "22": "Distribuzione posta frontale",
            "23": "Cassette lettere e pacchi CLASSIC",
            "25": "Startline verticali, prelievo frontale",
            "26": "Startline orizzontali, prelievo frontale",
            "27": "Startline porta laterale, prelievo posteriore",
            "29": "Budget porta laterale, prelievo posteriore",
            "30": "Cassette informative",
            "40": "Cassette concessionarie auto",
            "41": "Cassette farmacie",
            "42": "Cassette di sicurezza",
            "43": "Cassette giorno/notte",
            "50": "Modelli export Svizzera",
            "58": "Budget orizzontali, prelievo frontale",
            "60": "RENZ PLAN verticali, prelievo frontale",
            "61": "RENZ PLAN orizzontali, prelievo frontale",
            "62": "RENZ PLAN verticali, prelievo posteriore",
            "63": "RENZ PLAN steli",
            "64": "RENZ PLAN S porta laterale",
            "65": "RENZ PLAN S montaggio a muro, posteriore",
            "67": "RENZ PLAN S verticali, prelievo frontale",
            "68": "RENZ PLAN SL orizzontali, Svizzera",
            "78": "MEFA",
            "90": "Ricambi con incisione",
            "97": "Ricambi"
        }
    },
    "general": {
        "foldIn": "Comprimi",
        "removeExceptionFilter": "Rimuovi filtro. Nota: una regola d’eccezione senza filtro verrà eliminata automaticamente al salvataggio.",
        "exceptionWithoutFilter": "Le regole d’eccezione senza filtro vengono rimosse automaticamente. Salva i calcoli universali al di fuori delle eccezioni.",
        "foldOut": "Espandi",
        "logoutWarning": "Verrai disconnesso tra {logoutInMinutes} minuto{plural} se non viene effettuata alcuna azione.",
        "errorOccurred": "Si è verificato un errore! Ricarica la pagina e riprova più tardi.",
        "fullText": "Testo completo",
        "removeFilter": "Rimuovi filtro",
        "warning": "Avviso",
        "pushDown": "Sposta in basso",
        "pushUp": "Sposta in alto",
        "restore": "Ripristina",
        "ok": "OK",
        "yes": "Sì",
        "no": "No",
        "send": "Invia",
        "cancel": "Annulla",
        "save": "Salva",
        "close": "Chiudi",
        "back": "Indietro",
        "next": "Avanti",
        "delete": "Elimina",
        "edit": "Modifica",
        "noted": "Segnato",
        "note": "Segna",
        "beeingLoaded": "Caricamento in corso...",
        "pleaseWait": "Attendere prego...",
        "preview": "Anteprima",
        "logo": "Logo",
        "selectFile": "Seleziona file",
        "legend": "Legenda",
        "eMailAddress": "Indirizzo e-mail",
        "telephone": "Numero di telefono",
        "webAddress": "Indirizzo web",
        "add": "Aggiungi",
        "mr": "Sig.",
        "mrs": "Sig.ra",
        "others": "Altro",
        "planned": "Pianificato",
        "origin": "Origine",
        "positionShortName": "Pos.",
        "dealerDataNotFound": "Dati del rivenditore non trovati",
        "commission": "Commissione",
        "offer": "Offerta",
        "order": "Ordine",
        "actions": "Azioni",
        "loadMore": "... carica di più",
        "type": "Tipo",
        "selectType": "Seleziona tipo",
        "pageNotFound": "Pagina non trovata<br /><br />Percorso: {path}",
        "mandatoryField": "Campo obbligatorio",
        "dataStored": "Dati salvati",
        "description": "Descrizione",
        "and": "e",
        "rule": "Regola",
        "units": "Unità",
        "lookForValue": "Cerca valore",
        "copy": "Copia",
        "share": "Condividi",
        "entrance": "Ingresso",
        "exit": "Uscita",
        "reset": "⟳ reimposta",
        "apply": "Applica",
        "email": "E-mail",
        "phone": "Tel.",
        "duplicate": "Duplica",
        "accessKeyCreated": "Chiave d’accesso creata.",
        "accessKeyDeleted": "Chiave d’accesso rimossa.",
        "newVersionAvailable": "È disponibile una nuova versione del software.<br>La pagina verrà ricaricata.",
        "incompleteInfo": "Non tutte le<br>informazioni sono disponibili.<br><br>Riprova più tardi."
    }
}